/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { ListAllEquipmentForOfflineQueryResponse, ListAllEquipmentForOfflinePathParams, ListAllEquipmentForOfflineQueryParams, ListAllEquipmentForOffline400, ListAllEquipmentForOffline401, ListAllEquipmentForOffline403, ListAllEquipmentForOffline404, ListAllEquipmentForOffline409, ListAllEquipmentForOffline500 } from "../../types/equipmentController/ListAllEquipmentForOffline.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getListAllEquipmentForOfflineUrl(organizationId: ListAllEquipmentForOfflinePathParams["organizationId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/equipment/all` as const }
  return res
}

/**
 * @summary Full non-paginated fleet dataset for offline preparation (capped at 10 000)
 * {@link /api/organizations/:organizationId/equipment/all}
 */
export async function listAllEquipmentForOffline(organizationId: ListAllEquipmentForOfflinePathParams["organizationId"], params?: ListAllEquipmentForOfflineQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ListAllEquipmentForOfflineQueryResponse, ResponseErrorConfig<ListAllEquipmentForOffline400 | ListAllEquipmentForOffline401 | ListAllEquipmentForOffline403 | ListAllEquipmentForOffline404 | ListAllEquipmentForOffline409 | ListAllEquipmentForOffline500>, unknown>({ method : "GET", url : getListAllEquipmentForOfflineUrl(organizationId).url.toString(), params, ... requestConfig })
  return res.data
}